import { render, staticRenderFns } from "./partnersPage.vue?vue&type=template&id=558ca0a7&"
import script from "./partnersPage.vue?vue&type=script&lang=ts&"
export * from "./partnersPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports